import React, { useState } from "react";
import "../assets/css/ProductForm.css"; 


const ProductForm = ({ products, addToCart }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [quantity, setQuantity] = useState("");
  const [additionalValues, setAdditionalValues] = useState({});
  const [error, setError] = useState("");


  const handleProductChange = (e) => {
    const productId = e.target.value;
    const product = products.find((p) => p._id === productId);
    setSelectedProduct(product);
    setSelectedSize("");
    setAdditionalValues({});
  };

  const handleAdditionalFieldChange = (fieldLabel, value) => {
    setAdditionalValues((prev) => ({
      ...prev,
      [fieldLabel]: value,
    }));
  };

  const sizeMultiplier = {
    Whole: 1,
    Half: 0.5,
    Quarter: 0.25,
    Eighth: 0.125,
    Sixteenth: 0.0625,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedProduct || !selectedSize || !quantity) {
      setError("Please fill all fields.");
      return;
    }

    const newItem = {
      productId: selectedProduct._id,
      productType: selectedProduct.productType,
      size: selectedSize,
      quantity: parseInt(quantity, 10),
      price: selectedProduct.price,
      additionalValues,
      sizeMultiplier: sizeMultiplier[selectedSize],
      unitPrice: selectedProduct.price * sizeMultiplier[selectedSize]
    };
    addToCart(newItem);

    // Reset form
    setSelectedProduct(null);
    setSelectedSize("");
    setQuantity("");
    setAdditionalValues({});
  };

  return (
    <form className="modern-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Product</label>
        <select
          value={selectedProduct ? selectedProduct._id : ""}
          onChange={handleProductChange}
        >
          <option value="">Select product...</option>
          {products.map((product) => (
            <option value={product._id} key={product._id}>
              {product.productType}
            </option>
          ))}
        </select>
      </div>
      {selectedProduct && (
          <div className="product-info-box">
            <div><strong>Description:</strong> {selectedProduct.description}</div>
            <div><strong>Base Price:</strong> ${selectedProduct.price?.toLocaleString()}</div>
            <div><strong>Average Size:</strong> {selectedProduct.averageSize}</div>

            {selectedProduct.availableSizes && (
                <div style={{ marginTop: "8px" }}>
                  <strong>Price by Size:</strong>
                  <ul style={{ margin: 0, paddingLeft: "1rem" }}>
                    {selectedProduct.availableSizes.map((size) => {
                      const sizeMultiplier = {
                        Whole: 1,
                        Half: 0.5,
                        Quarter: 0.25,
                        Eighth: 0.125,
                        Sixteenth: 0.0625
                      };
                      const adjustedPrice = selectedProduct.price * (sizeMultiplier[size] || 1);
                      return (
                          <li key={size}>
                            {size}: ${adjustedPrice.toLocaleString()}
                          </li>
                      );
                    })}
                  </ul>
                </div>
            )}
          </div>
      )}


      {selectedProduct && (
          <div className="form-group">
            <label>Size</label>
            <select
              value={selectedSize}
              onChange={(e) => setSelectedSize(e.target.value)}
            >
              <option value="">Select size...</option>
              {selectedProduct.availableSizes &&
                selectedProduct.availableSizes.map((size) => (
                  <option value={size} key={size}>{size}</option>
                ))}
            </select>
          </div>
        )}

      <div className="form-group">
        <label>Quantity</label>
        <input
          type="number"
          min={1}
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          placeholder="Enter quantity"
        />
      </div>

      {selectedProduct && selectedProduct.additionalFields &&
        selectedProduct.additionalFields.map((field) => (
          <div className="form-group" key={field.label}>
            <label>{field.label}</label>
            <input
              type={field.type || "text"}
              value={additionalValues[field.label] || ""}
              onChange={(e) => handleAdditionalFieldChange(field.label, e.target.value)}
              placeholder={field.placeholder || ""}
            />
          </div>
        ))}

      {error && <div className="form-error">{error}</div>}

      <button className="primary-btn" type="submit">
        Add to Cart
      </button>
    </form>
  );
};


export default ProductForm;
